"use client";

import { useLocale } from "@/components/i18n/LocaleProvider";
import { getMessages } from "./messages";

/** Uses `LocaleProvider` (pathname + server `initialLocale`), not `useParams`, so copy matches `/zh/…` etc. */
export function useMessages() {
  const { locale } = useLocale();
  return getMessages(locale);
}
